import React from "react"
import { Link } from "gatsby"

import PropTypes from "prop-types"

import { css } from "@emotion/react"
import { useBreakpoint } from "gatsby-plugin-breakpoints"

import useMixins, { fontSize, globalColors } from "../css-functions"
import Image from "../image"

const LearnAbouthosokawaryu = ({
  pcTitle,
}) => {
  const bp = useBreakpoint()
  const mixins = useMixins()

  const style = {
    section: css`
      ${mixins.default.sectionStyle}
    `,
    title: css`
      ${mixins.default.generalTitleStyle}
    `,
    content: css`
      ${mixins.default.contentStyle}
    `,
    text: css`
      ${mixins.default.textStyle}
    `,
    list: css`
      padding-left: 12px;
      counter-reset: listitem;
    `,
    listItem: css`
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      ${bp.isTablet ? fontSize(13) : fontSize(11)}
      &::before {
        margin-right: 8px;
        counter-increment: listitem;
        content: counter(listitem)".";
      }
    `,
    iemoto: css`
      padding: ${ bp.isTablet ? '' : '0 16px' };
      display: grid;
      grid-template-columns: minmax( 148px, 200px ) minmax( 88px, 180px );
      column-gap: ${ bp.isTablet ? '40px' : '20px' };
      justify-content: center;
    `,
    iemotoContent: css`
      align-self: end;
    `,
    iemotoText: css`
      ${bp.isTablet ? fontSize(13) : fontSize(11)}
    `,
    iemotoName: css`
      margin-top: 8px;
    `,
    subTitle: css`
      margin-bottom: 12px;
      padding: 5px 0;
      border: 1px solid ${globalColors.gray};
      position: relative;
      ${bp.isTablet ? fontSize(16) : fontSize(14)}
      font-weight: 400;
      text-align: center;
      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background:
          linear-gradient(45deg, transparent 2px, ${globalColors.gray} 3px, transparent 4px),
          linear-gradient(135deg, transparent 2px, ${globalColors.gray} 3px, transparent 4px),
          linear-gradient(225deg, transparent 2px, ${globalColors.gray} 3px, transparent 4px),
          linear-gradient(315deg, transparent 2px, ${globalColors.gray} 3px, transparent 4px);
        background-position: bottom left,top left,top right,bottom right;
        background-size: 50% 50%;
        background-repeat: no-repeat;
      }
    `,
    imgWrapper: css`
      margin-bottom: 16px;
      display: grid;
      grid-auto-flow: column;
      column-gap: 12px;
    `,
    caption: css`
      margin-top: 8px;
      ${bp.isTablet ? fontSize(13) : fontSize(11)}
      font-family: "Noto Sans JP";
      font-weight: 200;
      text-align: center;
    `,
    navigateButton: css`
      ${ mixins.default.goDetailButtonStyle }
    `,
  }

  return (
    <>
      { pcTitle }
      <section css={style.section}>
        <h2 css={style.title}>ご挨拶</h2>
        <div css={style.content}>
          <p css={style.text}>　私ども細川流盆石は、平成22年4月1日をもって「一般財団法人　細川流盆石」を設立しました。法人を設立した目的は、江戸時代から受け継がれた盆石の伝承及び普及を通じて、日本伝統芸術のひとつとしての文化の保存、振興に寄与することを目的として、次の事業を行うことです。</p>
        </div>
        <div css={style.content}>
          <ol css={style.list}>
            <li css={style.listItem}>座開催による技術伝承</li>
            <li css={style.listItem}>指導者の育成</li>
            <li css={style.listItem}>機関紙の発行と継続</li>
            <li css={style.listItem}>盆石展の開催</li>
            <li css={style.listItem}>盆石紹介による国内及び海外における国際交流</li>
            <li css={style.listItem}>歴代家元の作品保存</li>
            <li css={style.listItem}>盆石に関する古書の保存</li>
            <li css={style.listItem}>その他当法人の目的を達成するために必要な事業</li>
          </ol>
        </div>
        <div css={style.content}>
          <p css={style.text}>　財団法人を設立しまして、初年度の事業として、平成22年9月22日より26日まで、「細川流盆石百年の歩み」と題して、東京銀座画廊にて、全国展を開催しました。</p>
          <p css={style.text}>　明治43年5月に、全国各地の景勝地を描いた「かつらの巻」を初代勝野博園が、版図として発行してから平成22年で丁度100年目に当ったからです。細川流盆石としては、明治43年（1910）からのこの100年を超す技術の伝承の流れを、皆様にご理解いただくために、今後とも、一般財団法人　細川流盆石の会員として、上記の目的に沿った活動を展開していく所存でございます。</p>
          <p css={style.text}>　皆様のご教示、多大なご支援を賜りたくお願い申し上げます。</p>
          <p css={style.text}>平成24年1月</p>
        </div>
        <div css={style.content}>
          <div css={style.iemoto}>
            <div css={style.iemotoContent}>
              <p css={style.iemotoText}>一般財団法人</p>
              <p css={style.iemotoText}>細川流盆石 代表理事</p>
              <p css={style.iemotoText}>細川流盆石 家元</p>
              <div css={style.iemotoName}>
                <Image filename="learn_img4.jpg" />
              </div>
            </div>
            <div css={style.iemotoContent}>
              <Image filename="learn_img5.jpg" />
            </div>
          </div>
        </div>
      </section>
      <section css={style.section}>
        <h2 css={style.title}>細川流盆石のあゆみ</h2>
        <div css={style.content}>
          <h3 css={style.subTitle}>石から砂の時代へ</h3>
          <p css={style.text}>　御所の文化として栄えた盆石を、現在ある様な形に完成したのは、茶人である武将の細川幽斎、三斎父子で、これより細川流盆石が誕生しました。</p>
          <p css={style.text}>　江戸時代中期には、日本各地の景勝地を盆石で表現する、｢盆山石図式｣、「盆山百景図｣等々、盆石の図版が発行され、｢石｣だけの時代から｢砂｣の時代へと移っていったのでした。そして床の間の普及と共に床飾りとしても盆石は発展して行きました。</p>
          <div css={style.imgWrapper}>
            <div>
              <figure>
                <Image
                  filename="learn_img6.jpg"
                />
                <figcaption css={style.caption}>細川 幽斎<br />（所蔵 出水神社）</figcaption>
              </figure>
            </div>
            <div>
              <figure>
                <Image
                  filename="learn_img7.jpg"
                />
                <figcaption css={style.caption}>細川 三斎<br />（所蔵 出水神社）</figcaption>
              </figure>
            </div>
          </div>
        </div>
        <div css={style.content}>
          <h3 css={style.subTitle}>初代家元による再興</h3>
          <p css={style.text}>　江戸末期、明治初年には、一時、盆石が衰退していたのを、盆石中興の祖・勝野博園が、明治四十三年に｢かつらの巻（日本百景）｣を出版し、ここに盆石の興隆を願ったのでした。博園は、江戸時代から伝わる後水尾天皇ゆかりの｢勅伝｣の本、｢利休好み二十八景高砂の盆｣などの古典の盆石を広く世に広めました。 </p>
          <div css={style.imgWrapper}>
            <figure>
              <div
                style={{
                  margin: "0 auto",
                  width: "50%",
                }}
              >
                <Image
                  filename="learn_img8.jpg"
                />
              </div>
              <figcaption css={style.caption}>初代家元　勝野 博園</figcaption>
            </figure>
          </div>
          <p css={style.text}>　先々代・勝野玄鵬は、現代的手法を用いて、写実的な味わいを出す事に成功しました。また色砂を使って、｢盆画｣を考案しております。</p>
          <p css={style.text}>　戦前の博園、玄鵬のこの時代は、盆石は興隆を極め、日本だけでなく、海外にも多くの支部が結成され、会員数は、一万人を越えました。</p>
          <p css={style.text}>　先代家元　勝野友禧子は、戦後の盆石界の復興を目指し、昭和38年の日本橋三越での盆石展をはじめとして、日本各地の文化教室に盆石の講座を開設しました。</p>
          <p css={style.text}>　盆石は、時代と共に生き、家屋の変化と共に、洋風空間にも調和する多様な形式の盆石が作られるようになってきました。 　現在、家元・勝野功子は、関東、東海、関西に教室を持ち、日本各地に支部が創設されており、門下生一同で、日本古来の伝統を守っております。</p>
        </div>
      </section>
      <section css={ style.section }>
        <Link
          to="/about/"
          css={ style.navigateButton }
        >
          盆石のはじまり
        </Link>
      </section>
    </>
  )
}

LearnAbouthosokawaryu.propTypes = {
  pcTitle: PropTypes.object,
}

export default LearnAbouthosokawaryu